import { all, fork } from "redux-saga/effects"

//public
import noticeType from "./noticeType/saga"
import Depots from "./depots/saga"
import User from "./usersManagement/saga"
import loginSaga from "./auth/saga"
import Driver from "./driverManagement/saga"
import noticeManagement from "./noticeManagement/saga"

/**
 * The root saga function that combines and runs all the individual sagas.
 * @returns None
 */
export default function* rootSaga() {
  yield all([
    //public
    fork(noticeType),
    fork(Depots),
    fork(User),
    fork(loginSaga),
    fork(Driver),
    fork(noticeManagement)
  ])
}
